// extracted by mini-css-extract-plugin
module.exports = {"table":"table--w4c84","upload":"upload--GrsV3","btnBox":"btnBox--jvKyh"};